<script>

import { Overlay } from '../../'
import { standardIndicator } from '../../workspace/standard-indicators.mjs'

export default {
    name: 'DPO',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Detrended Price Oscillator - Eliminates trend to highlight cycles',
                preset: {
                    name: 'DPO $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#00bcd4'
                    }
                }
            }
        },
        use_for() { return ['DPO'] },
        calc() {
            return {
                props: {
                    length: { def: 20, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `const count = Math.max(2, Math.floor(length)) * 2 + 1;
                    const values = series => Array.from({length:count},(_,i)=>series[i]);
                    return (${standardIndicator.toString()})('DPO',values(high),values(low),values(close),[],length);`
            }
        }
    }
}
</script>
